const DISPLAY_DATE_OPTIONS = { month: "long", day: "numeric", year: "numeric" };
export const FALLBACK_YEAR_FILTER = "All";

const toDate = (value) => new Date(value);
const getEventDate = (event) => toDate(event.date);

export function pickWebsiteUrl(event) {
  return (
    event.websiteUrl ||
    event.website ||
    event.url ||
    event.eventUrl ||
    event.link ||
    ""
  );
}

function isUpcomingEvent(event, today) {
  return getEventDate(event) >= today;
}

function sortByDateDesc(a, b) {
  return getEventDate(b) - getEventDate(a);
}

function sortByDateAsc(a, b) {
  return getEventDate(a) - getEventDate(b);
}

export function splitEventsByDate(events) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const grouped = events.reduce(
    (acc, event) => {
      if (isUpcomingEvent(event, today)) acc.upcoming.push(event);
      else acc.past.push(event);
      return acc;
    },
    { upcoming: [], past: [] }
  );

  // Upcoming reads soonest-first; past stays most-recent-first.
  grouped.upcoming.sort(sortByDateAsc);
  grouped.past.sort(sortByDateDesc);
  return grouped;
}

export function formatEventDate(startDate, endDate) {
  const start = toDate(startDate);
  if (!endDate) return start.toLocaleDateString("en-US", DISPLAY_DATE_OPTIONS);

  const end = toDate(endDate);
  if (start.getMonth() === end.getMonth()) {
    return `${start.getDate()} - ${end.getDate()} ${start.toLocaleDateString("en-US", { month: "long", year: "numeric" })}`;
  }
  return `${start.toLocaleDateString("en-US", DISPLAY_DATE_OPTIONS)} - ${end.toLocaleDateString("en-US", DISPLAY_DATE_OPTIONS)}`;
}

function getEventYear(event) {
  const year = getEventDate(event).getFullYear();
  return Number.isFinite(year) ? year : null;
}

export function buildYearOptions(pastEvents) {
  const years = [...new Set(pastEvents.map(getEventYear).filter(Boolean))].sort((a, b) => b - a);
  return [FALLBACK_YEAR_FILTER, ...years.map(String)];
}

export function filterPastEventsByYear(pastEvents, yearFilter) {
  if (yearFilter === FALLBACK_YEAR_FILTER) return pastEvents;
  const targetYear = Number(yearFilter);
  return pastEvents.filter((event) => getEventYear(event) === targetYear);
}
export const EVENTS_COPY = {
  upcoming:
    "Listed are events that NowPurchase is going to be a part of. These are tentative and can change at any time without prior notice.",
  previous: "Listed are events that NowPurchase has been a part of.",
  emptyUpcomingTitle: "No Upcoming Events",
  emptyUpcomingText: "Check back later for future events.",
  emptyPreviousNoData: "No previous events yet.",
  emptyPreviousNoYear: "No events for this year.",
};